import { PropsWithChildren, ReactNode } from 'react';

export interface MembershipOverviewRowProps extends PropsWithChildren {
  leftItem: ReactNode;
  rightItem?: ReactNode;
}

export const MembershipOverviewRow = (props: MembershipOverviewRowProps): JSX.Element => {
  const { leftItem, rightItem, children } = props;

  return (
    <div className="membership-overview-row gap-1">
      {leftItem || <></>}
      {rightItem || <></>}
      {children || <></>}
    </div>
  );
};
